import axios from "axios";

export const BACKEND = process.env.REACT_APP_BACKEND_URL;
export const api = axios.create({ baseURL: `${BACKEND}/api`, withCredentials: true });

let refreshing = null;
api.interceptors.response.use(
  (r) => r,
  async (error) => {
    const cfg = error.config || {};
    const url = cfg.url || "";
    if (error.response?.status === 401 && !cfg._retry && (url.startsWith("/admin") || url.startsWith("/ops/admin"))) {
      cfg._retry = true;
      try {
        refreshing = refreshing || api.post("/auth/refresh");
        await refreshing;
        refreshing = null;
        return api(cfg);
      } catch (e) {
        refreshing = null;
      }
    }
    return Promise.reject(error);
  }
);

export function errMsg(e, fallback = "Bir hata oluştu. Lütfen tekrar deneyin.") {
  const d = e?.response?.data?.detail;
  if (!d) return e?.response ? fallback : "Bağlantı hatası. İnternet bağlantınızı kontrol edin.";
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => x?.msg || "").filter(Boolean).join(" ");
  return d.msg || fallback;
}

export const mediaUrl = (u) => (u && u.startsWith("/api/") ? `${BACKEND}${u}` : u);
export const SITE_URL = process.env.REACT_APP_SITE_URL;
export function absUrl(u) {
  if (!u) return `${SITE_URL}/img/hero.webp`;
  return u.startsWith("http") ? u : `${SITE_URL}${u}`;
}
export const telHref = (phone) => `tel:${(phone || "").replace(/[^\d+]/g, "")}`;
export const waHref = (s) =>
  `https://wa.me/${(s?.whatsapp || "").replace(/\D/g, "")}?text=${encodeURIComponent(s?.whatsapp_message || "")}`;
export const fmtDate = (iso) =>
  iso ? new Date(iso).toLocaleString("tr-TR", { dateStyle: "short", timeStyle: "short" }) : "-";
